export const isLocalEnvironment = document.location.host === 'localhost:3000';

export const isTestEnvironmentInlife = document.location.host === 'lk-test2.in-life.ru';

export const isTestEnvironmentSCBInside = document.location.host === 'service-sk-test.sovcombank.group';

export const isTestEnvironment = isTestEnvironmentInlife || isTestEnvironmentSCBInside;

export const isProdEnvironmentInlife = document.location.host === 'lk.in-life.ru';

export const isProdEnvironmentSCB = document.location.host === 'service.sovcomlife.ru';

export const isProdEnvironmentSCBInside = document.location.host === 'lk2.uvp-sk-web-app1.sovcombank.group';

export const isProdEnvironment = isProdEnvironmentInlife || isProdEnvironmentSCB || isProdEnvironmentSCBInside;

export const getCaptchaSiteKey = () => {
    if (isProdEnvironmentInlife) {
        return 'ysc1_MmPKCyWrKMIaCwGpM2EuNrltQhTdklPP0HSPyIsE915f1129';
    }
    if (isProdEnvironmentSCB) {
        return 'ysc1_vWcG8b5AD0Ri4wIyZluJCa9GH5AK3dzNczmain56b5e42b83';
    }
    if (isTestEnvironmentInlife) {
        return 'ysc1_vh54qjx1TqbshSNJvMAZzEQaPSTpNegaCeiyi4Tv00a8686d';
    }
    return '';
};

export const sanitizeText = (value) => (typeof value === 'string' ? value.replace(/<[^>]*>/g, '') : value);
